<template>
  <div class="inheritance-toggle">
    <div class="uk-margin">
      <label>
        <input
          type="checkbox"
          class="uk-checkbox"
          v-model="isOverridden"
          @input="onInput"
        />
        {{toggleLabel}}
      </label>
    </div>

    <div
      v-if="isOverridden"
      class="inheritance-toggle__container inheritance-toggle__container--overridden"
    >
      <slot />
    </div>
    <div
      v-else
      class="inheritance-toggle__container inheritance-toggle__container--inherited"
    >
      <slot name="inherited" />
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox';
import InheritanceToggle from '@/mixins/InheritanceToggle';

export default {
  name: 'inheritance-toggle',
  mixins: [InheritanceToggle],
  components: {
    Checkbox,
  },
};
</script>

<style lang="scss">
.inheritance-toggle__container--inherited {
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// InheritanceToggle.vue?1f2438ba